import React from "react";

const SectionShell = ({ title, subtitle, actions, children }) => {
  return (
    <section
      style={{
        background: "transparent",
        border: "1px solid var(--border, #e8e8e8)",
        borderRadius: 14,
        padding: 18,
        display: "grid",
        gap: 14,
      }}
    >
      {(title || subtitle || actions) && (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: 12,
            flexWrap: "wrap",
          }}
        >
          <div style={{ display: "grid", gap: 4 }}>
            {title ? (
              <h2
                style={{
                  margin: 0,
                  fontSize: "1.05rem",
                  fontWeight: 800,
                  color: "var(--text, #222)",
                }}
              >
                {title}
              </h2>
            ) : null}

            {subtitle ? (
              <div
                style={{
                  color: "var(--text-secondary, #666)",
                  fontSize: ".92rem",
                }}
              >
                {subtitle}
              </div>
            ) : null}
          </div>

          {actions ? <div>{actions}</div> : null}
        </div>
      )}

      <div style={{ display: "grid", gap: 14 }}>{children}</div>
    </section>
  );
};

export default SectionShell;